import { FC, useEffect } from 'react';
import { navigate, PageProps } from 'gatsby';
import { Loading } from '../../components';
import { isBrowser } from 'lib/util/isBrowser';
import { Metadata, MetadataProps } from 'lib/ui-components/src';

const ReferralRedirectPage: FC<PageProps<object, object, unknown, { referralCode: string }>> = pageData => {
  const { referralCode } = pageData.params;

  const metadata: MetadataProps = {
    title: 'Get 35% Off Your First NIBLL Box',
    description: `Sign up now and your friend will also get a discount on their next box. Don't miss out on this great offer for delicious ready-made food from NIBLL.`
  };

  useEffect(() => {
    if (isBrowser) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.append('referralCode', referralCode);

      navigate(`/getting-started?${searchParams.toString()}`);
    }
  }, [referralCode]);

  return (
    <>
      <Metadata {...metadata} />
      <Loading />
    </>
  );
};

export default ReferralRedirectPage;
